import { useEffect } from "react";

export const errorMessage = {
  connectLite2Response: {
    connectLv: {},
    connectionOffer: {},
    costing: {},
    design: {},
    screenshots: {
      design: null,
      quotationPlan: null,
    },
    lvAceMessages: null,
    messages: [
      {
        code: "F500",
        description: "Unable to display user interface",
        level: 1,
        link: "",
      },
    ],
    study: {},
    processedStudy: {},
  },
};
const ErrorBoundaryFallback = (): JSX.Element => {
  useEffect(() => {
    window.parent.postMessage(
      {
        message: JSON.stringify(errorMessage, null, "\t"),
      },
      "*"
    );
  }, []);
  return (
    // You can render any custom fallback UI
    <h1 style={{ margin: "auto", width: "fit-content", fontWeight: "bolder" }}>
      Something went wrong.
    </h1>
  );
};
export default ErrorBoundaryFallback;
